import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { MetaDataSelect } from "../../components/forms/AutoCompleteFormItem";
import {
  ClientCategoriesSelect,
  ClientsSelect,
} from "../../components/forms/AutoCompleteFormItem";
import SupportingCommunity from "./formItems/SupportingCommunity";
import NursingItems from "./formItems/NursingItems";
import DayCenterItems from "./formItems/DayCenterItems";
import { useSuperAdmin } from "../../hooks/accessControl";

const OrderFormRows = ({
  form,
  clientCategories,
  orderIsUsed,
  onClientCategoriesChanged,
  filter,
  selectedClient,
  hasEditorPermission,
  getServiceTypeLabel,
  serviceType,
  startDate,
  disabledFromDate,
  disabledDate,
  noEndDate,
  isTrom,
  filterOrderServiceTypes,
  filterContracts,
  filterClientFrameSymbols,
  filterClientTariffSymbols,
  activeOrder,
  changedValues,
  isSupportingCommunity,
  isDayCenter,
  type,
  scopePrefix,
  activePatient,
  intl,
  onClientCategoryChange,
  onClientsChanged,
  selectedClientTariffSymbol,
  selectedRevahaAuthority,
}) => {
  const [showAdditionalItems, setShowAdditionalItems] = useState(false);
  const isSuperAdmin = useSuperAdmin();
  const values = form?.getFieldsValue();
  useEffect(() => {
    const { client_id, order_service_type_id } = values;
    if (client_id && order_service_type_id && values["client.category_id"]) {
      setShowAdditionalItems(true);
    } else {
      setShowAdditionalItems(false);
    }
  }, [values]);
  return (
    <>
      <Row>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <ClientCategoriesSelect
            name="client.category_id"
            category="order"
            required={true}
            extraParams={{ scopePrefix }}
            disabled={orderIsUsed && !isSuperAdmin}
            onDataChanged={onClientCategoriesChanged}
            onChange={(val) => onClientCategoryChange?.(val)}
            additionalRules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const category = clientCategories.find((i) => i.id === value);

                  const notAllowed =
                    category &&
                    category.group_prospectus_by_patients &&
                    category.paid_by_patient_account &&
                    !activePatient.payments?.self_payment;

                  if (!notAllowed) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error(
                      intl.formatMessage({
                        id: "app.forms.order.patient_needs_payments_filled",
                      })
                    )
                  );
                },
              }),
            ]}
          />
          <MetaDataSelect
            name="order_service_type_id"
            category="order"
            metadataName="order_service_types"
            filterItems={filterOrderServiceTypes}
            required={true}
            disabled={orderIsUsed && !isSuperAdmin}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <ClientsSelect
            required={true}
            extraParams={{
              scopePrefix: scopePrefix,
              filter: filter,
            }}
            name="client_id"
            category="order"
            disabled={orderIsUsed && !isSuperAdmin}
            onDataChanged={(val) => onClientsChanged?.(val)}
          />
        </Col>
      </Row>
      {showAdditionalItems && (
        <>
          {isSupportingCommunity ? (
            <SupportingCommunity
              serviceType={serviceType}
              startDate={startDate}
              disabledFromDate={disabledFromDate}
              disabledDate={disabledDate}
              noEndDate={noEndDate}
              isTrom={isTrom}
              activeOrder={activeOrder}
              changedValues={changedValues}
              type={type}
              selectedClient={selectedClient}
              scopePrefix={scopePrefix}
            />
          ) : isDayCenter ? (
            <DayCenterItems
              hasEditorPermission={hasEditorPermission}
              orderIsUsed={orderIsUsed}
              serviceType={serviceType}
              startDate={startDate}
              disabledFromDate={disabledFromDate}
              disabledDate={disabledDate}
              noEndDate={noEndDate}
              isTrom={isTrom}
              filterContracts={filterContracts}
              activeOrder={activeOrder}
              changedValues={changedValues}
              type={type}
              selectedClient={selectedClient}
              scopePrefix={scopePrefix}
              hasMasavChargeEnabled={activePatient?.masav_charge?.enabled}
            />
          ) : (
            <NursingItems
              hasEditorPermission={hasEditorPermission}
              orderIsUsed={orderIsUsed}
              serviceType={serviceType}
              getServiceTypeLabel={getServiceTypeLabel}
              startDate={startDate}
              disabledFromDate={disabledFromDate}
              disabledDate={disabledDate}
              noEndDate={noEndDate}
              isTrom={isTrom}
              filterContracts={filterContracts}
              filterClientFrameSymbols={filterClientFrameSymbols}
              filterClientTariffSymbols={filterClientTariffSymbols}
              activeOrder={activeOrder}
              changedValues={changedValues}
              type={type}
              selectedClient={selectedClient}
              scopePrefix={scopePrefix}
              selectedClientTariffSymbol={selectedClientTariffSymbol}
              selectedRevahaAuthority={selectedRevahaAuthority}
            />
          )}
        </>
      )}
    </>
  );
};

export default OrderFormRows;
